query GET_PARKER ($id: UUID!) {
  parker(id: $id) {
    email
    id
    phone
    user {
      avatar
      firstName
      lastName
      role
      signupCode
      hasRedeemedSignupCode
    }
    freeVouchers {
      id
      code
      isRedeemed
      redeemedOnDatetime
    }
    parkerCreditPacks {
      id
    }
    parkerParkingPacks {
      id
      order {
        status
      }
      parkingsUsed
      parkingPack {
        allowUnlimitedParkings
        allowedDailyReservationsForUnlimitedParkings
        allowedParkings
        createdDatetime
        description
        displayOrder
        name
        status
        weekdays
        facility {
          id
          lots {
            parkingSchedules {
              id
              name
              availableReservationTypes
            }
            applicableScheduleId
          }
        }
      }
    }
    vehicles {
      color
      id
      licenseNumber
      make
      model
      registeredState
      status
      type
      frontProfile
      rearProfile
    },
    reservations {
      cancellationDatetime
      id
      checkinDatetime
      checkoutDatetime
      closingTime
      openingTime
      status
      updatedDatetime
      isRental
      type
      vehicle {
        licenseNumber
        make
        model
      }
      lot {
        id
        parkerInstructions
        name
        facility{
          images {
            file
          }
        address{
          address1
          address2
          city
          state
          zipCode
        }
      }
      }
      order {
        id
        amount
        receipt
        finalAmount
        itemsMetadata
      }
      review {
        feedback
        rating
        isRecommended
        status
        rewardCredited
      }
    }
    wallet {
      credits
      id
    }
  }
}
